import classNames from 'classnames';

import { Link as LinkAsButton, LinkVariant, RenderType } from '@jsmdg/yoshi';
import { type Location } from '../../../shared/types';
import styles from './VenuesList.module.scss';

type VenuesListItemProps = {
    readonly venue: {
        id: string;
        displayName: string;
    };
    readonly onVenueClicked: (id: string) => void;
    readonly activeVenue: Location;
};

const VenuesListItem = ({
    activeVenue,
    onVenueClicked,
    venue,
}: VenuesListItemProps): JSX.Element => {
    return (
        <li className="ml-2x">
            <LinkAsButton
                dataTestId={`cityMapLink${venue.displayName}`}
                className={classNames({
                    [styles.activeVenue]: activeVenue?.externalId === venue.id,
                })}
                onClick={() => onVenueClicked(venue.id)}
                as={RenderType.Button}
                variant={LinkVariant.Grey}
            >
                {venue.displayName}
            </LinkAsButton>
        </li>
    );
};

export { VenuesListItem };
